import {
  Box,
  Button,
  Container,
  Heading,
  SimpleGrid,
  Text,
  useColorModeValue,
  Badge,
  VStack,
  HStack,
  useToast,
} from '@chakra-ui/react';
import { CheckIcon } from '@chakra-ui/icons';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { plans } from '../hooks/plans';
import Footer from '../components/layout/footer';

const SubscriptionPage = () => {
  const [selectedPlan, setSelectedPlan] = useState<string | null>(null);
  const navigate = useNavigate();
  const toast = useToast();

  const green = '#009800ff';
  const bg = useColorModeValue('white', 'gray.700');

  const handlePlanSelect = (planName: string) => {
    setSelectedPlan(planName);
  };

  const handleNext = () => {
    if (!selectedPlan) return;

    const today = new Date();
    const trialEnds = new Date();
    trialEnds.setDate(today.getDate() + 7);

    const planInfo = {
      // selectedPlan,
      // trialStart: today.toISOString(),
      // trialEnd: trialEnds.toISOString(),
      // isTrialActive: true,
      tier: selectedPlan || null,
      is_trial: true,
      trial_days: 7,
      billing_cycle_days: 30,
    };

    localStorage.setItem('subscriptionPlanInfo', JSON.stringify(planInfo));

    toast({
      title: `Plan Selected: ${selectedPlan}`,
      description: `Your 7-day free trial starts now and ends on ${trialEnds.toDateString()}`,
      status: 'success',
      duration: 4000,
      isClosable: true,
    });

    navigate('/organization/create');
  };

  return (
    <Container maxW="7xl" py={12}>
      <VStack spacing={8} align="stretch">
        <Box>
          <HStack justifyContent={'space-between'} alignItems={'center'} py={3}>
            <Heading size="md" mb={4}>
              Choose a Plan for your Business
            </Heading>
            {selectedPlan && (
              <Box textAlign="right">
                <Button
                  bg={'#009800ff'}
                  color="white"
                  _hover={{ bg: '#009800ff' }}
                  onClick={handleNext}
                >
                  Next
                </Button>
              </Box>
            )}
          </HStack>
          <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={6}>
            {plans.map((plan, idx) => {
              const isSelected = selectedPlan === plan.index;
              return (
                <Box
                  key={idx}
                  p={6}
                  rounded="lg"
                  shadow="md"
                  cursor="pointer"
                  onClick={() => handlePlanSelect(plan?.index)}
                  border={isSelected ? `3px solid #009800ff` : '1px solid #ccc'}
                  bg={isSelected ? 'green.50' : '#fff'}
                  transition="all 0.2s"
                >
                  <HStack mb={2} justify="space-between" flexWrap={'wrap'}>
                    <Heading size="lg">{plan.name}</Heading>
                    {/* <Badge colorScheme='orange' fontSize="sm" mb={4}>7 days free trial</Badge> */}
                    {isSelected && <Badge colorScheme="green">Selected</Badge>}
                  </HStack>
                  <Text fontSize="xl" fontWeight="bold" mb={1}>
                    {plan.price}
                  </Text>
                  <Text fontSize="sm" mb={4}>
                    {plan.users}
                  </Text>
                  <VStack align="start" spacing={2} mb={4}>
                    {plan.features.map((feature, i) => (
                      <HStack key={i}>
                        <CheckIcon boxSize={3} color={green} />
                        <Text>{feature}</Text>
                      </HStack>
                    ))}
                  </VStack>
                </Box>
              );
            })}
          </SimpleGrid>
        </Box>

        {selectedPlan && (
          <Box textAlign="right">
            <Button
              bg={green}
              color="white"
              _hover={{ bg: '#009800ff' }}
              onClick={handleNext}
            >
              Next
            </Button>
          </Box>
        )}
      </VStack>
      <Footer />
    </Container>
  );
};

export default SubscriptionPage;
